import {
    AnimationBaseController,
    Collisions,
    GameRandom,
    IAnimationControllerConfiguration,
    Inject,
} from '@denishussar/html5-game-engine';
import { GameLogic } from '../../../../Logic/GameLogic';
import { AnimationContents } from '../../../../../AnimationContents';
import {
    ButtonController,
    IButtonControllerOptions,
} from '../../../../Common/ButtonController';
import {
    MiniGameModel,
    MiniGameTypeEnum,
} from '../../../../Models/Game/MiniGameModel';

export class FlyersStandController extends AnimationBaseController {
    $model: MiniGameModel;

    private _width: number = 0;
    private _height: number = 0;

    private _screenWidth: number = 0;
    private _screenHeight: number = 0;
    private _screenScale: number = 1;

    public completeCount: number = 0;
    public randNumArray = new Array();

    public constructor(
        @Inject private _options,
        @Inject private _gameLogic: GameLogic,
        @Inject private _random: GameRandom,
        @Inject private _collisions: Collisions
    ) {
        super('FlyersStandController');
    }

    protected getConfiguration(): IAnimationControllerConfiguration {
        let childControllers = {};

        do {
            const randNum = this._random.integer(0, 7);
            this.randNumArray.indexOf(randNum) === -1 &&
                this.randNumArray.push(randNum);
        } while (this.randNumArray.length < 4);

        for (let i = 0; i < 4; i++) {
            childControllers[`book${this.randNumArray[i]}`] = {
                instanceName: `book${this.randNumArray[i]}`,
                view: ButtonController,
                model: this.$model,
                options: <IButtonControllerOptions>{
                    onClick: () => {
                        const child = this.$childControllers.get(
                            `book${this.randNumArray[i]}`
                        ) as ButtonController;
                        if (child) {
                            child.display.interactive = false;
                            child.display.interactiveChildren = false;

                            this.gotoAndPlayByQuery(
                                `book${this.randNumArray[i]}.book`,
                                `type${i % 3}`,
                                false,
                                false
                            );

                            if (++this.completeCount >= 4) {
                                this._gameLogic.onMiniGameComplete(
                                    MiniGameTypeEnum.stand_flyers
                                );
                            }
                        }
                    },
                },
            };
        }

        return {
            animationContent: AnimationContents.GAME_SCREEN_JSON,
            libraryName: 'mini_games_stand_flyers',
            childControllers: childControllers,
            modelWatch: {
                visible: (visible: boolean) => {
                    this.visible = visible;
                },
            },
        };
    }

    protected onInitialize(): void {
        this.visible = this.$model.visible;

        for (let i = 0; i < 4; i++) {
            this.setAnimationControlByParentByQuery(
                `book${this.randNumArray[i]}.book`,
                false
            );
            this.setAnimationControlByParentByQuery(
                `book${this.randNumArray[i]}.book.skin`,
                false
            );
            this.gotoAndStopByQuery(
                `book${this.randNumArray[i]}.book`,
                `type${i % 3}`
            );
            this.gotoAndStopByQuery(
                `book${this.randNumArray[i]}.book.skin`,
                this._random.integer(0, 3)
            );
        }
        // for (let i = 0; i < 4; i++) {
        //     this.setAnimationControlByParentByQuery(`book${this.randNumArray[i]}.book`, false);
        //     this.setAnimationControlByParentByQuery(`book${this.randNumArray[i]}.book.skin`, false);
        //     this.gotoAndStopByQuery(`book${this.randNumArray[i]}.book`, `type0`);
        //     this.gotoAndStopByQuery(`book${this.randNumArray[i]}.book.skin`, this._random.integer(0, 3));
        // }

        this._width = this.display.width;
        this._height = this.display.height;
    }

    protected onResize(width: number, height: number, scale: number) {
        this._screenWidth = width;
        this._screenHeight = height;
        this._screenScale = scale;

        this.updateScale();
    }

    protected onLandscape(): void {
        this.updateScale();
    }

    protected onPortrait(): void {
        this.updateScale();
    }

    private updateScale(): void {
        this.display.scale.set(
            Math.min(
                this._screenWidth / this._width / this._screenScale,
                this._screenHeight / this._height / this._screenScale
            )
        );
    }
}
